import { useAuthStore } from '../stores/auth';
import type { RouteLocationNormalized } from 'vue-router';

// Permission-based route guard
export const requirePermission = (permission: string) => {
  return (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: any) => {
    const authStore = useAuthStore();
    
    if (!authStore.isAuthenticated) {
      next('/login');
      return;
    }

    if (!authStore.hasPermission(permission as any)) {
      next('/unauthorized');
      return;
    }

    next();
  };
};

// Authentication guard
export const requireAuth = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: any) => {
  const authStore = useAuthStore();
  
  if (!authStore.isAuthenticated) {
    next('/login');
    return;
  }

  next();
};

// Guest guard (redirect authenticated users away from auth pages)
export const requireGuest = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: any) => {
  const authStore = useAuthStore();
  
  if (authStore.isAuthenticated) {
    // Redirect based on user type
    const userType = authStore.user?.userType;
    if (userType === 'lawyer') {
      next('/lawyers');
    } else if (userType === 'firm_admin') {
      next('/firm-offices');
    } else {
      next('/');
    }
    return;
  }

  next();
};

// Role-specific guards
export const requireLawyer = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: any) => {
  const authStore = useAuthStore();
  
  if (!authStore.isAuthenticated) {
    next('/login');
    return;
  }

  if (authStore.user?.userType !== 'lawyer') {
    next('/unauthorized');
    return;
  }

  next();
};

export const requireFirmAdmin = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: any) => {
  const authStore = useAuthStore();
  
  if (!authStore.isAuthenticated) {
    next('/login');
    return;
  }

  if (authStore.user?.userType !== 'firm_admin') {
    next('/unauthorized');
    return;
  }

  next();
};

export const requireClientOrUser = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: any) => {
  const authStore = useAuthStore();
  
  if (!authStore.isAuthenticated) {
    next('/login');
    return;
  }

  const userType = authStore.user?.userType;
  if (userType !== 'client' && userType !== 'user') {
    next('/unauthorized');
    return;
  }

  next();
};
